import React, { useState } from 'react';
import { Box, Container, Heading } from '@hover/blueprint';
import { ArrowButton, DownloadAppModal } from '@hover/shared-components';
import { navigate } from 'gatsby';
import { useMediaQuery } from '@chakra-ui/react';
import { useABTesting } from '../../hooks';
import { ctaABTesting } from '../../utils/ctaABTesting';

const TransformBusiness: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [isDesktop] = useMediaQuery('(min-width: 1280px)');
  const abTestValue = useABTesting({
    testName: 'pros-restoration-cta-pressed',
  });

  if (!abTestValue) return <>Loading...</>;

  const toggleModal = () => {
    if (!isDesktop) setIsOpen(!isOpen);
    else if (abTestValue === 'A') {
      ctaABTesting('A');
      setIsOpen(!isOpen);
    } else {
      ctaABTesting('B');
      void navigate('/signup');
    }
  };

  return (
    <Box
      w="100%"
      justifyContent="center"
      py={1000}
      bg="brandNavy.500"
      mb={1000}
    >
      <DownloadAppModal isOpen={isOpen} onClose={toggleModal} />
      <Container
        w="100%"
        maxW="1200px"
        px={{ base: 500, tablet: '56px' }}
        centerContent
      >
        <Heading
          as="h2"
          color="neutral.0"
          textAlign="center"
          size={{ base: 500, tablet: 600, desktop: 700 }}
          marginBottom={{ base: 500, desktop: 500 }}
        >
          Transform your business with new workflow features.
        </Heading>
        <Heading
          as="p"
          isDisplay
          color="neutral.0"
          textAlign="center"
          size={{ base: 300, tablet: 500 }}
          marginBottom={{ base: 700, desktop: 700 }}
          maxW="2xl"
        >
          From estimates and proposals to supplier-direct material ordering,
          HOVER helps you optimize and grow.
        </Heading>
        <ArrowButton
          colorScheme="brandNavy"
          variant="inverted"
          onClick={toggleModal}
          w={{ base: '100%', tablet: 'auto' }}
        >
          Try for Free
        </ArrowButton>
      </Container>
    </Box>
  );
};

export default TransformBusiness;
